import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import WorkOrderStatusBadge from '#/modules/momMgmt/workOrder/components/WorkOrderStatusBadge';
import { mapWorkOrderMeta } from '#/modules/momMgmt/workOrder/helper/mapWorkOrderMeta';
import { formatDisplayQty } from '#/utils/formatNumber';

function formatInboundQuantityLabel(detail) {
  const qty = detail?.quantity;
  if (!qty) {
    return '—';
  }
  const manufacturing = qty.manufacturingQty;
  const expected = qty.expectedReceiptQty;
  if (manufacturing == null && expected == null) {
    return '—';
  }
  if (expected != null && manufacturing != null) {
    return `製造 ${formatDisplayQty(manufacturing)}／預計入庫 ${formatDisplayQty(expected)}`;
  }
  return formatDisplayQty(manufacturing ?? expected);
}

const WorkOrderInboundSummaryCard = ({ detail }) => {
  const meta = mapWorkOrderMeta(detail);
  const mtrName = detail?.mtr?.name || '—';
  const mtrNo = detail?.mtr?.mtrNo || '';

  return (
    <div className="receipt-card-elevate">
      <div className="receipt-card-surface p-5">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="min-w-0 space-y-1">
            <div className="flex flex-wrap items-center gap-2">
              <h2 className="text-lg font-semibold text-slate-800">
                {meta.code || '—'}
              </h2>
              {detail?.status ? (
                <WorkOrderStatusBadge status={detail.status} size="sm" />
              ) : null}
            </div>
            <div className="min-w-0">
              <p className="truncate text-sm font-medium text-slate-800">{mtrName}</p>
              {mtrNo ? (
                <p className="truncate text-xs text-muted-foreground">{mtrNo}</p>
              ) : null}
            </div>
          </div>
          <div
            className={cn(
              'grid min-w-48 grid-cols-1 gap-2 text-sm',
              'sm:grid-cols-2',
            )}
          >
            <div>
              <p className="text-xs text-muted-foreground">目標倉</p>
              <p className="font-medium text-slate-800">{meta.targetWarehouse}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground">數量</p>
              <p className="font-medium text-slate-800">{formatInboundQuantityLabel(detail)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

WorkOrderInboundSummaryCard.propTypes = {
  detail: PropTypes.object.isRequired,
};

export default WorkOrderInboundSummaryCard;
